// extracted by mini-css-extract-plugin
export var dropdownIcon = "_nz-6";
export var imgContainer = "_nz-3";
export var menuIcon = "_nz-5";
export var pillWrapper = "_nz-2";
export var pillsContainer = "_nz-1";
export var subscriptionCard = "_nz-0";
export var subscriptionLogo = "_nz-4";